import { GraphBuilder } from '../graph/builder';
import { ComponentDef } from './types';

export const syntheticDataPipelineComponent: ComponentDef = {
  id: 'synthetic-data-pipeline',
  name: 'Synthetic Data Pipeline',
  description: 'Generate, filter, and annotate synthetic training examples with a teacher model and quality scorer.',
  category: 'training',
  params: [
    { name: 'd_model', label: 'Model dimension', type: 'number', default: 512, min: 64, max: 4096, step: 64 },
    { name: 'seq_len', label: 'Sequence length', type: 'number', default: 128, min: 1, max: 8192, step: 1 },
    { name: 'n_samples', label: 'Samples', type: 'number', default: 1024, min: 1, max: 65536, step: 128 }
  ],
  buildGraph: (params) => {
    const d_model = Number(params.d_model);
    const seq_len = Number(params.seq_len);
    const n_samples = Number(params.n_samples);

    const g = new GraphBuilder();
    g.input('seed', [seq_len, d_model]);

    g.replicate('prompts', 'seed', [seq_len, d_model], Math.min(n_samples, 8));
    g.linear('teacher', 'prompts', [d_model, d_model]);
    g.linear('response', 'teacher', [d_model, d_model]);
    g.metric('quality', 'response', 'Quality Score');
    g.scale('filter', 'quality', 'Threshold');
    g.output('out', 'filter');
    return g.build();
  }
};
